class FreeShipping extends HTMLElement {
  connectedCallback() {
    this.update();
    document.addEventListener('cart:updated', (e) => {
      const cartData = e.detail.cartData || e.detail.cart;
      if (cartData) this.dataset.cartTotal = cartData.total_price;
      this.update();
    });
  }

  getThreshold() {
    const country = this.dataset.country;
    const currency = this.dataset.currency;
    const espt = this.dataset.thresholdEsPt;
    if (espt && (country === 'ES' || country === 'PT')) {
      return parseFloat(espt);
    }

    const thresholdsRaw = this.dataset.thresholds;
    if (!thresholdsRaw) return null;

    // Wrap in {} if not already a JSON object (metaobject may store without braces)
    const jsonStr = thresholdsRaw.trim().startsWith('{') ? thresholdsRaw : `{${thresholdsRaw}}`;

    try {
      const parsed = JSON.parse(jsonStr);
      return parsed[currency] != null ? parseFloat(parsed[currency]) : null;
    } catch (e) {
      console.warn('[free-shipping] JSON.parse failed:', e.message, '| raw:', jsonStr);
      // Fallback: regex parse
      const match = thresholdsRaw.match(new RegExp(`"${currency}"\\s*:\\s*"?([\\d.]+)"?`));
      return match ? parseFloat(match[1]) : null;
    }
  }

  update() {
    const threshold = this.getThreshold();
    if (threshold == null) {
      this.style.display = 'none';
      this.classList.add('hide-free-shipping');
      return;
    }

    const thresholdCents = threshold * 100;
    const cartTotal = parseInt(this.dataset.cartTotal || '0', 10);
    const remaining = thresholdCents - cartTotal;
    const percent = Math.min(100, Math.round((cartTotal / thresholdCents) * 100));

    const bar = this.querySelector('.free-shipping__bar');
    const fill = this.querySelector('.free-shipping__bar-fill');
    const msg = this.querySelector('.free-shipping__message');
    const badge = this.querySelector('.free-shipping__badge');
    const labelMin = this.querySelector('.free-shipping__label--min');
    const labelMax = this.querySelector('.free-shipping__label--max');

    if (bar) {
      bar.setAttribute('aria-valuenow', percent);
    }

    if (fill) {
      fill.style.width = `${percent}%`;
    }

    // Endpoint labels: 0 → threshold
    if (labelMin) labelMin.textContent = this._formatMoney(0);
    if (labelMax) labelMax.textContent = this._formatMoney(thresholdCents);

    if (remaining <= 0) {
      this.classList.add('free-shipping--unlocked');
      if (msg) msg.innerHTML = "You've <strong>unlocked Free Shipping</strong>";
      if (badge) badge.hidden = true;
    } else {
      this.classList.remove('free-shipping--unlocked');
      const remainingMoney = this._formatMoney(remaining);
      if (msg) msg.innerHTML = `You're ${remainingMoney} away from <strong>Free Shipping</strong>`;
      // Floating badge showing current cart total, positioned at fill %
      if (badge) {
        badge.hidden = false;
        badge.textContent = this._formatMoney(cartTotal);
        badge.style.left = `${percent}%`;
      }
    }

    const minLabel = this.querySelector('.free-shipping__range-min');
    const maxLabel = this.querySelector('.free-shipping__range-max');
    if (minLabel) minLabel.textContent = this._formatMoney(0);
    if (maxLabel) maxLabel.textContent = this._formatMoney(thresholdCents);
  }

  _formatMoney(cents) {
    const format = window.Shopify?.moneyFormat || '{{amount}}';
    const amount = cents / 100;
    const plain = Number.isInteger(amount) ? amount.toFixed(0) : amount.toFixed(2);
    const withComma = plain.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    const noDecimals = String(Math.round(amount));
    const noDecimalsComma = noDecimals.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return format
      .replace('{{amount_with_comma_separator}}', withComma)
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimalsComma)
      .replace('{{amount_no_decimals}}', noDecimals)
      .replace('{{amount}}', plain);
  }
}

customElements.define('free-shipping', FreeShipping);
